// ===========================================
// Authentication API Functions
// ===========================================
// API calls for password reset endpoints

import { apiClient } from '../services/api';

// ===========================================
// TYPES
// ===========================================

export interface ForgotPasswordRequest {
  email: string;
  /** The school the forgot-password page is under (#600); keeps the lookup in one school. */
  schoolSlug?: string;
}

export interface ForgotPasswordResponse {
  status: 'success';
  message: string;
}

export interface VerifyResetTokenResponse {
  status: 'success';
  data: {
    valid: boolean;
    /** Only present when valid. */
    purpose?: 'RESET' | 'ACCOUNT_SETUP';
  };
}

export interface ResetPasswordRequest {
  token: string;
  newPassword: string;
}

export interface ResetPasswordResponse {
  status: 'success';
  message: string;
}

// ===========================================
// API FUNCTIONS
// ===========================================

/**
 * Request a password reset email
 */
export async function forgotPassword(
  data: ForgotPasswordRequest
): Promise<ForgotPasswordResponse> {
  return apiClient.post<ForgotPasswordResponse>('/auth/forgot-password', data);
}

/**
 * Verify if a password reset token is valid
 */
export async function verifyResetToken(
  token: string
): Promise<VerifyResetTokenResponse> {
  return apiClient.get<VerifyResetTokenResponse>(`/auth/verify-reset-token/${token}`);
}

/**
 * Reset password using a valid token
 */
export async function resetPassword(
  data: ResetPasswordRequest
): Promise<ResetPasswordResponse> {
  return apiClient.post<ResetPasswordResponse>('/auth/reset-password', data);
}
